/* eslint-disable @typescript-eslint/no-unused-vars */
import { SECUNDARIO, TERCIARIO } from "src/styles/styles"
import { ConceptoVerificacion } from "src/utils/aspirantes/verificaciones"
import { EstadoAspirante } from "src/utils/constantes"
import { Ipageable } from "./general"

// Obtener aspirantes
export type IobtenerAspirantesRequest = {
    perfil?: string
    nombres?: string
    apellidos?: string
    estado?: string
    identificacion?: string
    usuarioAsignadoId?: string
    paginador?: Ipageable
  }

export type IitemAspiranteResponse = {
    aspiranteId: string
    nombres: string
    apellidos: string
    correo: string
    perfilId: string
    nombrePerfil: string
    estado: EstadoAspirante
    usuarioAsignadoId: string
    nombreUsuarioAsignado: string
    identificacion: string
    fechaCreacion: string
    fechaRadicado: string
    numeroRadicado: string
    perfilNombre: string

  }

export type IobtenerAspirantesResponse = {
    result: IitemAspiranteResponse[];
    total: number;
    page: number;
    returnedRecords: number;
}

// export enum EstadoAspirante {
//     RECIBIDO = 'RECIBIDO',
//     EN_REVISION = 'EN_REVISION',
//     RECHAZADO = 'RECHAZADO',
//     DEVUELTO = 'PENDIENTE_INFORMACION',
//     APROBADO = 'APROBADO',
// }

// export const EstadoAspiranteProps = {
//     [EstadoAspirante.RECIBIDO]: { label: 'Recibido', color: '#8f9ba1' },
//     [EstadoAspirante.EN_REVISION]: { label: 'En revisión', color: '#32b5ed' },
//     [EstadoAspirante.RECHAZADO]: { label: 'Rechazado', color: 'red' },
//     [EstadoAspirante.DEVUELTO]: { label: 'Pendiente información', color: '#FFA800' },
//     [EstadoAspirante.APROBADO]: { label: 'Aprobado', color: SECUNDARIO },
// }

// Estado verificacion campos
export enum EstadoCampo {
  RECHAZAR = 'RECHAZAR',
  PENDIENTE = 'PENDIENTE',
  APROBAR = 'APROBAR',
  DEVUELTO = 'DEVUELTO',
}

export const EstadoCampoProps = {
  [EstadoCampo.RECHAZAR]: { label: 'Rechazar', color: 'red' },
  [EstadoCampo.PENDIENTE]: { label: 'Sin gestionar', color: '#32b5ed' },
  [EstadoCampo.APROBAR]: { label: 'Aprobar', color: SECUNDARIO },
  [EstadoCampo.DEVUELTO]: { label: 'Devolver', color: '#FFA800' },
}

// Asignar usuario gestor
export type IasignarGestorRequest = {
  aspiranteId: string,
  usuarioId: string
}


// Obtener aspirante por Id
export type IdetalleAspiranteResponse = {
  aspiranteId: string
  tipoIdentificacion: string
  identificacion: string
  primerNombre: string
  segundoNombre: string
  primerApellido: string
  segundoApellido: string
  fechaNacimiento: string
  sexo: string
  correoElectronico: string
  estado: EstadoAspirante
  numeroCelular: string
  departamentoResidenciaId: number
  municipioResidenciaId: number
  perfilId: string
  documentoIdentidadAdjuntoId: string
  tarjetaProfesionalAdjuntoId: string
  certificadoContraloriaAdjuntoId: string
  certificadoProcuraduriaAdjuntoId: string
  certificadoPoliciaNacionalAdjuntoId: string
  certificadoRnmcAdjuntoId: string
  fechaExpedicionTarjetaProfesional: string
  horariosDisponibles: string[]
  sedesDisponibles: string[]
  formacionesAcademicas: FormacionesAcademica[]
  experienciasLaborales: ExperienciasLaborale[]
  usuarioAsignadoId: string
  numeroRadicado: string
  fechaRadicado: string
  observacionRechazo: string
}

export interface FormacionesAcademica {
  formacionAcademicaId: string
  nombreTituloObtenido: string
  nombreInstitucion: string
  fechaGraduacion: string
  soporteId: string
}

export interface ExperienciasLaborale {
  experienciaLaboralId: string
  tipo: string
  nombreEmpresaInstitucion: string
  fechaInicio: string
  fechaFin: string
  resumenFunciones: string
  nombreJefeInmediato: string
  telefonoJefeInmediato: string
  soporteId: string
}

// Obtener verificaciones aspirante

export interface IobtenerVerificacionesRequest {
  aspiranteId: string;
  token?: string;
}

export interface VerificacionResponse {
  verificacionId: string
  aspiranteId: string
  concepto: ConceptoVerificacion
  estado: string
  comentarios: string
  usuarioVerificadorId: string
  fechaVerificacion: string
}

// Enviar solicitud
export interface IregistroHojaDeVidaRequest {
  informacion: any
}

export interface IregistroHojaDeVidaResponse {
  
}

// Guardar revision de hoja de vida
export interface IguardarVerificacionHojaDeVida {
  verificaciones: any[]
}

// Editar hoja de vida
export interface IEditarHojaDeVidaRequest {
  aspiranteId: string
  informacion: any
  token?: string
  actualizacionDocente?: boolean;
}


// Cambiar estado aspirante
export interface IguardarEstadoAspirante {
  aspiranteId: string;
  estado: string
  observacionRechazo?: string;
}

// Obtener estados aspirante

export interface IobtenerEstadosDisponiblesRequest {
  aspiranteId: string;
}